<h2 mat-dialog-title>Les données du patient</h2>
<mat-dialog-content>
    <app-patient-identity [patient]="patient" [cardinfo]="cardinfo" [displaymode]="displaymode"></app-patient-identity>
    <app-patient-address [patient]="patient" [displaymode]="displaymode"></app-patient-address>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-stroked-button (click)="close('ok')">Fermer</button>
    <button mat-button mat-stroked-button (click)="close('updateAndSelect')">Mettre à jour et sélectionner</button>
</mat-dialog-actions>